<template id="regForm">
<section class="contentArea">
  <div class="container">
    <div class="row text-center">
      <div class="col-md-12 col-sm-12">
        <div><img src="images/sent.jpg" alt="" class="sentIcon"></div>
        <h2 class="thankHeading">{{res.chkemail}}</h2>
        <p v-html="res.onlyvalid"></p>
      </div>
      <div class="col-md-12 col-sm-12">
        <div class="centerbutton sent">
          <input v-on:click="goLogin($event)" class="redButon" :value="res.login" type="submit">
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>

import utils from './Utils.vue'

function readURL(input, func) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      func(e.target.result);
    }
    reader.readAsDataURL(input.files[0]);
  }
}

export default {
  name: 'pwdSent',
  props:['name', 'clients', 'firstamts', 'countries', 'res'],
  data () {
    return {
      reseller:{},
      token:null,
      submitted:false,
      error:{}
    }
  },
  components: {
  },
  created: function() {
  },
  methods: {
    goLogin:function(event) {
      window.location.href='reglogin.html';
    }
  },
  mounted: function() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PwdSent.vue